export default __webpack_public_path__ + "d8b3e69.png";